module.exports = __webpack_public_path__ + "static/media/about.e82c16d6.jpg";